import { useQuery } from "@tanstack/react-query";
import React from "react";
import { withNamespaces } from "react-i18next";
import { toast } from "react-toastify";
import { Row } from "reactstrap";
import LicenseManagementService from "src/modules/3rd-party-management/apis/admin/LicenseManagementService";
import LoadingContent from "../kyb-common-components/loading-content";
import CreditCards from "../kyb-common-components/credit-cards";

/**
 * Total, used and remaining count of an organization limit.
 * `limitKey` is "thirdParties" or "newsMonitoring".
 */
const Limits = ({ t, limitKey }) => {
    const { data, isFetching } = useQuery({
        queryKey: ["3rd-party-management-fetch-organization-limits"],
        queryFn: async () => {
            const service = LicenseManagementService.getInstance();

            return await service.fetchLimits();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t("An error occurred while fetching overview content."), {
                type: "error",
            });
        },
    });

    if (isFetching) {
        return <LoadingContent />;
    }

    const limit = data?.[limitKey];

    return (
        <div className="overview-tab">
            <Row>
                <CreditCards
                    totalCredits={limit?.total || 0}
                    totalUsage={limit?.used || 0}
                    remaining={limit?.remaining || 0}
                />
            </Row>
        </div>
    );
};

export default withNamespaces()(Limits);
